import { SVGProps } from "react";
import * as React from "react";

export const StopIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2158 21.6022H11.7158V21.5893C17.1307 21.323 21.4342 16.8171 21.4383 11.3035V11.3032C21.4383 5.61932 16.8655 1.00461 11.2158 1.00461C5.56611 1.00461 0.993407 5.61985 0.993407 11.3037C0.993407 16.9875 5.56665 21.6022 11.2158 21.6022ZM0.5 11.3037C0.5 5.33318 5.30121 0.5 11.2158 0.5C17.13 0.5 21.9317 5.33319 21.9317 11.3037C21.9317 17.2742 17.1305 22.1073 11.2158 22.1073C5.30121 22.1073 0.5 17.2742 0.5 11.3037Z"
      fill={props.fill}
      stroke={props.stroke}
    />
    <path
      d="M8.64453 14.0783V8.52734H14.0834V14.0783H8.64453Z"
      fill={props.fill}
      stroke={props.stroke}
    />
  </svg>
);
